import { useMemo } from 'react';
import { useApi } from '../infrastructure/useApi';
import { DEFAULT_API_OPTIONS } from '../infrastructure/defaults';
import { API_URLS } from '../apiUrls';
import { API_METHODS } from '../constants/apiMethods';

/**
 * Hook for accessing Documents API methods.

 * Usage:
 * const { getFile, cancel } = useDocumentsApi();
 * await getFile({ fileName: 'example.pdf', id: '123' });
 *
 * Cancellation scope:
 * - cancel() applies to requests started by this hook instance.
 * - For independent cancellation scopes, create separate hook instances.
 */
export const useDocumentsApi = (baseOptions = DEFAULT_API_OPTIONS) => {
	const { call, cancel } = useApi(baseOptions);

	return useMemo(
		() => ({
			getFile: ({ fileName, id }) =>
				call({
					url: API_URLS.documents.getFile({
						fileName,
						id,
					}),
					method: API_METHODS.GET_BLOB,
				}),

			cancel,
		}),
		[call, cancel]
	);
};
